import React from 'react';
import cs from 'classnames';
import css from './index.css';
import StateList from '../../common/StateList';
import sharedCSS from '../../shared.css';
import stateData from '../../../misc/country-info';
import { getUrlQeury } from '../../../misc/formatUrlquery';
import { browserHistory } from 'react-router';

const CityList = (props) => {
  const query = getUrlQeury() || {}
  const state = query.from_state || query.from_state_name
  const country = query.from_country || query.from_country_name
  const countryList = stateData[country] || []
  const stateList = countryList.filter(x => x.value === state)
  const stateFullName = stateList.length ? stateList[0].label : ''
  const citys = stateList.length ? stateList[0].city : []
  if (citys.length) {
    return (
      <div className={cs(sharedCSS.wide, css.container)}>
        <p className={css.title}>Major Cities in { stateFullName }</p>
        <div className={css.cityContainer}>
          {
            citys.map(item => (
              <span
                key={item.label}
                className={css.cityItem}
                onClick={() => {browserHistory.push(`/searchloads/${stateFullName}/${item.label}/all-loads?dho=200&limit=50&offset=0&show_option=all&sort_by=age&sort_order=asc&from_country_name=${country}&from_state_name=${state}&from_city=${item.label}&from_country=${country}&from_lat=${item.lat}&from_lng=${item.lng}&from_name=${item.label}, ${state}&from_state=${state}`)}}
                // href={}
              >{ item.label }</span>
            ))
          }
        </div>
      </div>
    )
  }
  return <div className={cs(sharedCSS.wide, css.container)}><StateList /></div>
}

export default CityList;



// WEBPACK FOOTER //
// ./src/components/search/cityList/index.js